<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="dialogState"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      primaryButtonShow: true,
      primaryButtonText: primaryButtonText,
      secondaryButtonText: secondaryButtonText,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: triggerExport,
      primaryButtonDisabled: primaryButtonDisabled
    }"
  >
    <div class="d-flex flex-col w-100" slot="dialog_data">
      <loader v-if="exportJobInProgress" />
      <div>
        <p>{{ optionsText }}</p>
        <export-options-list
          :exportOptionsArray="exportOptionsArray"
          :selectedOption="selectedOption"
          @updateSelectedOption="updateSelectedOption"
        />
      </div>
    </div>
  </x-dialog>
</template>
<script>
const ExportOptionsList = () =>
  import('@/components/ArchiveSearch/ExportOptionsModal/ExportOptionsList');
import { mapState } from 'vuex';
export default {
  data() {
    return {
      exportOptionsArray: [],
      loadingState: false,
      primaryButtonText: 'Confirm',
      secondaryButtonText: 'Cancel',
      primaryButtonDisabled: true,
      dialogState: false,
      availableSelections: [],
      selectedOption: ''
    };
  },
  components: { ExportOptionsList },
  props: {
    operationType: String,
    exportJobInProgress: Boolean
  },
  computed: {
    ...mapState(['activeConnectors']),
    dialogTitle() {
      return `${this.operationType} Options`;
    },
    optionsText() {
      return `Select where you want to ${this.operationType} your file(s)`;
    }
  },
  mounted() {
    this.initData();
    this.getExportOptions();
  },
  methods: {
    initData() {
      const currentConnector = this.connectorArchiveNameMap(
        this.$route.params.connectorType?.toUpperCase()
      );

      const currentConnectorId =
        currentConnector?.id ||
        this.$enums.O365_CONNECTORS.onedrive.connectorId;

      this.selectedOption = this.$enums.defaultExportPointMap[
        currentConnectorId
      ];
      this.openDialog();
    },
    openDialog() {
      this.dialogState = true;
    },
    closeDialog() {
      this.dialogState = false;
      this.$emit('closeDialog');
    },
    triggerExport() {
      this.$emit('triggerExport', this.selectedOption);
    },
    async getExportOptions() {
      try {
        this.loadingState = true;
        const { success, results } = await this.getConnectorsSourceDetails();

        if (success) {
          const exportableConnectors = this.filterExportableConnectors(results);

          this.exportOptionsArray = this.mapConsent(exportableConnectors);
          this.setDefaultSelectedOption();
        }
      } catch (error) {
        this.snackbar('error', error);
      } finally {
        this.loadingState = false;
      }
    },
    /**
     * Funtion :- To get all connectors having exportable = true
     * @param {Array} connectorsSourceDetails , array of connector's source details
     */
    filterExportableConnectors(connectorsSourceDetails) {
      return connectorsSourceDetails.filter(
        ({
          data: {
            sourceDetails: { EXPORTABLE, SOURCE_ID }
          }
        }) => {
          const isDropbox =
            SOURCE_ID === this.$enums.O365_CONNECTORS.dropbox.connectorId;

          // For dropbox connector, check dropbox accessiblity for org along with "EXPORTABLE" flag
          if (isDropbox) {
            return this.isDropboxAccessible && EXPORTABLE;
          }

          return EXPORTABLE;
        }
      );
    },
    /**
     * Funtion :- To map consent of corresponding connector responsible to use export feature for every exportable connector
     * For ex: "Dropbox Export" connector is responsible to use export for "Dropbox" connector
     *
     * @param {Array} exportableConnectors , array of exportable connectors
     */
    mapConsent(exportableConnectors) {
      return exportableConnectors.map(connectorSourceDetails => {
        const {
          data: {
            sourceDetails: { SOURCE_ID }
          }
        } = connectorSourceDetails;

        // To get corresponding connector source Id responsble to use export feature
        const exportConnectorSourceId = this.$enums
          .connectorsWritePermissionMap?.[SOURCE_ID];

        // To get corresponding connector subscription details responsble to use export feature
        const exportConnectorSubscriptionDetails = this.activeConnectors.find(
          ({
            data: {
              subscriptionDetails: { SOURCE_ID }
            }
          }) => exportConnectorSourceId === SOURCE_ID
        );

        let hasConsent = false;

        if (exportConnectorSubscriptionDetails) {
          const {
            data: {
              subscriptionDetails: { HAS_CONSENT }
            }
          } = exportConnectorSubscriptionDetails;

          hasConsent = HAS_CONSENT;
        }

        if (hasConsent) {
          // To enable primary button of Dialog if any exportable connector is enabled (means HAS_CONSENT = true)
          this.enablePrimaryButton();
          this.availableSelections.push(SOURCE_ID);
        }

        // Append HAS_CONSENT flag to source details of exportable connectors
        return {
          ...connectorSourceDetails,
          data: {
            ...connectorSourceDetails.data,
            sourceDetails: {
              ...connectorSourceDetails.data.sourceDetails,
              HAS_CONSENT: hasConsent
            }
          }
        };
      });
    },
    enablePrimaryButton() {
      this.primaryButtonDisabled = false;
    },
    /**
     * Function:- availableSelections is array for available selection options for target place to export having HAS_CONSENT = true
     * Checking if selectedOption is not present in availableSelections, then set selectedOption to 1st availableSelections
     */
    setDefaultSelectedOption() {
      if (
        !this.availableSelections.includes(this.selectedOption) &&
        this.availableSelections.length
      ) {
        this.selectedOption = this.availableSelections[0];
      }
    },
    updateSelectedOption(sourceId) {
      this.selectedOption = sourceId;
    }
  }
};
</script>
